import React from 'react'

import { useTranslation } from 'react-i18next'

import direction from '../../../assets/direction.png'
import { SectionText } from '../../../components/SectionText'

interface ContactProps {
    className?: string
}

export const Contact: React.FC<ContactProps> = ({ className }) => {
    const { t } = useTranslation()
    return (
        <div
            id="contact"
            className={`${className} flex justify-between min-h-[500px] w-full text-primary-blue
            sm:flex-col sm:h-auto sm:min-h-[1000px]
        `}>
            <div className="w-3/5 h-full flex items-center justify-center sm:w-full sm:py-3 sm:px-3">
                <SectionText
                    className="max-w-[400px]"
                    title={t('footer.contact.title')}
                    hrLineColor="bg-primary-orange"
                    discoverMore={false}>
                    {t('footer.contact.address')} <br />
                    {t('footer.contact.city')} <br /> <br />
                    {t('imprint.contact.phone')}{' '}
                    <a href="tel:+496514604488" className="hover:underline">
                        {' '}
                    </a>{' '}
                    <br />
                    {t('imprint.contact.fax')} <br />
                    <a href="mailto:termin@kinderchirurgie-trier.de" className="hover:underline">
                        {t('footer.contact.email')}
                    </a>{' '}
                    <br />
                </SectionText>
            </div>
            <div className="w-2/5 h-full flex items-center justify-start sm:w-full sm:items-start sm:justify-center">
                <img src={direction} className="h-[400px] w-auto" alt="direction" />
            </div>
        </div>
    )
}
